export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5024.2671b45b.jpg";